export const HUB_COLORS = {
  ring: "#7A9AD4",
  label: "#1a237e",
  hubSubtitle: "#9e9e9e",
  hubTitle: "#1a237e",
  hubShadow: "0 8px 32px rgba(26, 35, 126, 0.12)",
};

export type HubNodeConfig = {
  title: string;
  angle: number;
  ring: "inner" | "outer";
  bgColor: string;
  iconColor: string;
  iconKey: string;
  path?: string;
  external?: boolean;
  disabled?: boolean;
};

export const HUB_CENTER_URL = "http://172.24.4.73:8080/auth";
export const HUB_CENTER_SIZE = 148;
export const INNER_RING_RADIUS = 132;
export const OUTER_RING_RADIUS = 232;
export const HUB_SIZE = 600;
export const HUB_NODE_CIRCLE_SIZE = 64;
export const HUB_NODE_ICON_SIZE = 32;
export const HUB_NODE_LABEL_FONT_SIZE = "0.8rem";
export const HUB_NODE_LABEL_MAX_WIDTH = 100;

export const HUB_NODES: HubNodeConfig[] = [
  {
    title: "Customer",
    angle: 0,
    ring: "inner",
    bgColor: "#d1f7e8",
    iconColor: "#00897b",
    iconKey: "customer",
    path: "/login",
  },
  {
    title: "Admin",
    angle: 210,
    ring: "inner",
    bgColor: "#e1f5fe",
    iconColor: "#1e88e5",
    iconKey: "admin",
    path: "/admin/login",
  },
  {
    title: "Agent",
    angle: 150,
    ring: "inner",
    bgColor: "#fff9c4",
    iconColor: "#f4511e",
    iconKey: "agent",
    path: "/agent/login",
  },
  {
    title: "Submission Portal",
    angle: 270,
    ring: "outer",
    bgColor: "#ffe0b2",
    iconColor: "#f4511e",
    iconKey: "submission portal",
    path: "https://xymphony-broker.netlify.app",
    external: true,
  },
  {
    title: "ASK",
    angle: 0,
    ring: "outer",
    bgColor: "#f3e5f5",
    iconColor: "#7b1fa2",
    iconKey: "ask",
    path: "http://172.24.4.73:5173/ask",
    external: true,
  },
  {
    title: "Workers Comp",
    angle: 90,
    ring: "outer",
    bgColor: "#e1f5fe",
    iconColor: "#1e88e5",
    iconKey: "workers comp",
    path: "https://xymphony-nlx.netlify.app",
    external: true,
  },
];
